import { CartAddEvent } from '@theme/events';

class VJCartDiscovery extends HTMLElement {
  static observedAttributes = ['data-remaining'];
  attributeChangedCallback() { queueMicrotask(() => this.rankProducts()); }
  connectedCallback() {
    this.removeEventListener('click', this.addProduct);
    this.addEventListener('click', this.addProduct);
    this.rankProducts();
  }
  rankProducts() {
    const remaining = Number(this.dataset.remaining);
    const cards = [...this.querySelectorAll('[data-price]')];
    const heading = this.querySelector('.vj-cart-discovery__heading');
    if (heading) heading.hidden = cards.length === 0;
    cards.sort((a, b) => {
      const pa = Number(a.dataset.price), pb = Number(b.dataset.price);
      const ca = pa >= remaining, cb = pb >= remaining;
      return ca !== cb ? (ca ? -1 : 1) : ca ? pa - pb : pb - pa;
    });
    cards.forEach((card, index) => { card.style.order = index; card.hidden = index > 1; });
  }
  disconnectedCallback() { this.removeEventListener('click', this.addProduct); }
  addProduct = async (event) => {
    const button = event.target.closest('button[data-variant]');
    if (!button || button.disabled) return;
    const error = this.querySelector('[role="alert"]');
    error.hidden = true;
    button.disabled = true;
    button.textContent = 'Añadiendo…';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))];
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.variant), quantity: 1 }], sections: sections.slice(0, 5), sections_url: location.pathname })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'No se ha podido añadir el producto. Inténtalo de nuevo.');
      const cartResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) { window.location.reload(); return; }
      const cart = await cartResponse.json();
      document.dispatchEvent(new CartAddEvent(cart, 'vj-cart-discovery', { source: 'vj-cart-discovery', itemCount: cart.item_count, sections: result.sections }));
      button.textContent = 'Añadido';
    } catch (cause) {
      error.textContent = cause.message || 'No se ha podido añadir el producto. Inténtalo de nuevo.';
      error.hidden = false;
      button.disabled = false;
      button.textContent = 'Añadir';
    }
  };
}
if (!customElements.get('vj-cart-discovery')) customElements.define('vj-cart-discovery', VJCartDiscovery);
